import { createFileRoute } from '@tanstack/react-router'

import { MyDevices } from '@/components/common/my-devices'

export const Route = createFileRoute('/_authenticated/my/devices' as never)({
  component: MyDevicesPage,
})

function MyDevicesPage() {
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight">我的设备</h1>
        <p className="text-muted-foreground">查看分配给您的设备</p>
      </div>
      <MyDevices />
    </div>
  )
}
